/**
 * Helps define `shouldForwardProp` for MUI's `styled` helper.
 * @example
 * ```typescript
 * styled(MuiCard, {
 *   shouldForwardProp: dontForwardProps('myProperty'),
 * })<{ myProperty?: boolean }>(impl);
 * ```
 */
export function dontForwardProps<P extends PropertyKey[]>(
  ...names: P
): (property: PropertyKey) => boolean {
  return (property) => !names.includes(property);
}
